import { Injectable } from '@nestjs/common';
import { Repository, RepositoryNotTreeError } from 'typeorm';
import { OverTimeCategory } from './overtime-category.entity';
import { OverTimeCatDTO } from './dto/overtime-category.dto';
import { InjectRepository } from '@nestjs/typeorm';
import { OverTimeCatAdapter } from './dto/overtime-category.adapter';
import { OverTimeCategoryResponse, AllOverTimeCategoriesResponse } from '@gtpl/shared-models/hrms';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { OverTimeCatRequest } from './dto/overtime-category.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
@Injectable()
export class OvertimeCategoryService {
    constructor(
      private logService:LogsService,

        @InjectRepository(OverTimeCategory)
        private overTimeCatRepo: Repository<OverTimeCategory>,
        private overTimeCatAdapter: OverTimeCatAdapter,
    ){}

    async getOverTimeCatDetailsWithoutRelations(overTimeCategoryName: string): Promise<OverTimeCategory>{
       const overTimeCatResponse = await this.overTimeCatRepo.findOne({
           where: {overTimeCategoryName: overTimeCategoryName},
       });
       if(overTimeCatResponse){
           return overTimeCatResponse;
       }else{
           return null;
       }
    }

    async createOverTimeCategory(overTimeCatDto: OverTimeCatDTO, isUpdate: boolean): Promise<OverTimeCategoryResponse>{
        try{
            if(!isUpdate){
                const overTimeCatEntity = await this.getOverTimeCatDetailsWithoutRelations(overTimeCatDto.overTimeCategoryName);
                if(overTimeCatEntity){
                    throw new ErrorResponse(11104, 'Over Time Category already exists');
                }
            }
            else{
                const overTimeCatEntity = await this.getOverTimeCatDetailsWithoutRelations(overTimeCatDto.overTimeCategoryName);
                if(overTimeCatEntity){
                    if(overTimeCatEntity.overTimeCategoryId != overTimeCatDto.overTimeCategoryId){
                        throw new ErrorResponse(11104, 'Over Time Category already exists');
                    }
                }
            }
            const convertedEntity: OverTimeCategory = this.overTimeCatAdapter.converDtoToEntity(overTimeCatDto, isUpdate);
            const savedEntity: OverTimeCategory = await this.overTimeCatRepo.save(
                convertedEntity
            );
            const savedDto: OverTimeCatDTO = this.overTimeCatAdapter.convertEntityToDto(convertedEntity);
            if(savedDto){
                const response = new OverTimeCategoryResponse(true, 1, isUpdate? 'Over Time Category Updated Successfully' : 'Over Time Category Created Successfully');
                const name=isUpdate?'updated':'created'
            
                const newLogDto = new LogsDto(1,name, 'OverTimeCategory', savedDto.overTimeCategoryId, true, '',savedDto.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;                
            } else {
                throw new ErrorResponse(11106,'Over Time Category saved but issue while transforming it into DTO');
            }
        }catch(error){
            throw error;            
        }
    }

    async getAllOverTimeCats(): Promise<AllOverTimeCategoriesResponse>{
        try{
            const overTimeCatDtos: OverTimeCatDTO[] = [];
            const overTimeCatEntities: OverTimeCategory[] = await this.overTimeCatRepo.find({order: {overTimeCategoryName: 'ASC'}});
            if(overTimeCatEntities){
                overTimeCatEntities.forEach(otcEntity =>{
                    const convertedDto: OverTimeCatDTO = this.overTimeCatAdapter.convertEntityToDto(otcEntity);
                    overTimeCatDtos.push(convertedDto);
                });
                const response = new AllOverTimeCategoriesResponse(true, 1, 'Over Time Categories retrieved successfully', overTimeCatDtos);
                const newLogDto = new LogsDto(1,'view', 'OverTimeCategory', 0, true, '','')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            }else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }            
        }catch(err){
            throw err;
        }
    }

    async getAllActiveOverTimeCats(): Promise<AllOverTimeCategoriesResponse>{
        try{
            const otcDtos: OverTimeCatDTO[] = [];
            const otcEntities: OverTimeCategory[] = await this.overTimeCatRepo.find({order: {overTimeCategoryName: 'ASC'}, where:{isActive:true},});
            if(otcEntities){
               otcEntities.forEach(Entity => {
                   const convertedDto: OverTimeCatDTO = this.overTimeCatAdapter.convertEntityToDto(Entity);
                   otcDtos.push(convertedDto);
               });
               const response = new AllOverTimeCategoriesResponse(true, 11108, "Over Time Categories Retrieved Successfully", otcDtos);
               return response;
            }else{
                throw new ErrorResponse(99998, 'Data not found');
            }
        }catch(err){
            throw err;
        }
    }

    async getOverTimeCatById(categoryId: number): Promise<OverTimeCategory>{
        const response = await this.overTimeCatRepo.findOne({
            where: {overTimeCategoryId: categoryId},
        });
        if(response){
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateCategory(catReq: OverTimeCatRequest): Promise<OverTimeCategoryResponse>{
        try{
            const catExists = await this.getOverTimeCatById(catReq.overTimeCategoryId);
            if(catExists) {
                if(catReq.versionFlag != catExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current over time category information. Refresh and try again');

                }else{
                    const catStatus = await this.overTimeCatRepo.update(
                        {overTimeCategoryId: catReq.overTimeCategoryId},
                        {isActive: catReq.isActive, updatedUser: catReq.updatedUser}
                    );
                    if(catExists.isActive) {
                        if(catStatus.affected){
                            const catResponse: OverTimeCategoryResponse = new OverTimeCategoryResponse(true, 10115, 'Over Time Category is de-activated successfully');
                            return catResponse;
                        }else{
                            throw new ErrorResponse(10111, 'Over Time Category is already deactivated');
                        }
                    }else {
                        if(catStatus.affected){
                            const catResponse: OverTimeCategoryResponse = new OverTimeCategoryResponse(true, 10114, 'Over Time Category is activated successfully');
                            return catResponse;
                        }else{
                            throw new ErrorResponse(10112, 'Over Time Category is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(err){
            throw err;
        }
    }
}
